import React, { useEffect, useState } from "react";
import {
    Card,
    Form,
    Input,
    Button,
    Select,
    Row,
    Col,
    message,
    Typography,
    Space
} from "antd";
import { ArrowLeftOutlined, SaveOutlined } from "@ant-design/icons";
import { useHistory, useParams } from "react-router-dom";
import axiosInstance from "../../../configs";

const { Title } = Typography;
const { Option } = Select;

export default function ContactForm() {
    const [form] = Form.useForm();
    const history = useHistory();
    const { id } = useParams();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (id) {
            setLoading(true);
            axiosInstance
                .get(`/contact/${id}`)
                .then((res) => {
                    form.setFieldsValue(res.data);
                })
                .catch((err) => {
                    message.error("Gagal mengambil data kontak");
                })
                .finally(() => setLoading(false));
        }
    }, [id, form]);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            if (id) {
                await axiosInstance.put(`/contact/${id}`, values);
                message.success("Kontak berhasil diperbarui");
            } else {
                await axiosInstance.post("/contact", values);
                message.success("Kontak berhasil dibuat");
            }
            history.push("/referensi/kontak");
        } catch (err) {
            console.error(err);
            message.error(err.response?.data?.error || "Gagal menyimpan data");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card bodyStyle={{ padding: "16px" }}>
            <div style={{ marginBottom: 16, display: "flex", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
                <Button
                    icon={<ArrowLeftOutlined />}
                    onClick={() => history.push("/referensi/kontak")}
                />
                <Title level={4} style={{ margin: 0 }}>
                    {id ? "Edit Kontak" : "Tambah Kontak Baru"}
                </Title>
            </div>

            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                initialValues={{ contact_type: 1 }}
            >
                <Row gutter={[16, 0]}>
                    <Col xs={24} sm={12}>
                        <Form.Item
                            label="Nama Kontak"
                            name="name"
                            rules={[{ required: true, message: "Nama wajib diisi" }]}
                        >
                            <Input placeholder="Nama lengkap..." />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                        <Form.Item label="Jenis Kontak" name="contact_type">
                            <Select>
                                <Option value={1}>Customer / Pemilik</Option>
                                <Option value={0}>Vendor / Pemasok</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={[16, 0]}>
                    <Col xs={24} sm={12}>
                        <Form.Item label="Alamat" name="address">
                            <Input.TextArea rows={2} placeholder="Alamat lengkap..." />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                        <Form.Item label="Email" name="email">
                            <Input type="email" placeholder="Email..." />
                        </Form.Item>
                        <Form.Item label="Telepon" name="phone">
                            <Input placeholder="Nomor Telepon..." />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={[16, 0]}>
                    <Col xs={24} sm={12}>
                        <Form.Item label="NPWP" name="npwp">
                            <Input placeholder="Nomor NPWP..." />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                        <Form.Item label="Contact Person (PIC)" name="cp">
                            <Input placeholder="Nama PIC..." />
                        </Form.Item>
                    </Col>
                </Row>

                <Row justify="end" style={{ marginTop: 16 }}>
                    <Space wrap>
                        <Button onClick={() => history.push("/referensi/kontak")}>
                            Batal
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                            icon={<SaveOutlined />}
                            loading={loading}
                        >
                            Simpan
                        </Button>
                    </Space>
                </Row>
            </Form>
        </Card>
    );
}
